import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const StyledBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  background: #f3fee7;
  border-top: 1px solid #d0f8ab;
  border-bottom: 1px solid #d0f8ab;
`;

const StyledText = styled.span`
  font-size: 0.875rem;
  color: #2f5c1b;
  font-weight: 400;
  text-align: center;
  width: 100%;
`;

const StyledLearnMore = styled.a`
  color: #2b5314;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  padding: 0.1rem 0.25rem;
  border-radius: 0.25rem;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: #d0f8ab;
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid #2b5314;
    outline-offset: 2px;
    background-color: #d0f8ab;
    text-decoration: none;
  }
`;

type Props = {
  rewardAmount?: number;
};

export function RewardBanner({ rewardAmount }: Readonly<Props>) {
  const navigate = useNavigate();

  if (!rewardAmount) return null;

  return (
    <StyledBanner>
      <StyledText>
        Get a ${rewardAmount} bonus after move-in.{' '}
        <StyledLearnMore
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate('/how-it-works');
          }}
        >
          How it works {'→'}
        </StyledLearnMore>
      </StyledText>
    </StyledBanner>
  );
}
